    import * as XLSX from 'xlsx';
    import jsPDF from 'jspdf';
    import { companyInfo } from '../utils/dataInfo';

    // Helper function to get status name
    const getStatusName = (status) => {
    return status === 1 ? 'Active' : 'Inactive';
    };

    // Helper function to get branch name
    const getBranchName = (branchId, branchesData) => {
    if (!branchesData || !Array.isArray(branchesData)) return 'Unknown';
    const branch = branchesData.find(br => parseInt(br.id) === parseInt(branchId));
    return branch ? branch.name : 'Unknown';
    };

    // Helper function to get employee name
    const getEmployeeName = (employeeId, employeesData) => {
        console.log("getEmployeeName"+employeeId)
        console.log("employeesData"+JSON.stringify(employeesData))
    if (!employeesData || !Array.isArray(employeesData)) return 'Unknown';
    const employee = employeesData.find(emp => parseInt(emp.id) === parseInt(employeeId));
    return employee ? employee.employee_name : 'Unknown';
    };

    // Helper function to split text into multiple lines
    const splitTextIntoLines = (doc, text, maxWidth) => {
    const words = text.split(' ');
    const lines = [];
    let currentLine = words[0];

    for (let i = 1; i < words.length; i++) {
        const word = words[i];
        const width = doc.getTextWidth(currentLine + ' ' + word);
        if (width < maxWidth) {
        currentLine += ' ' + word;
        } else {
        lines.push(currentLine);
        currentLine = word;
        }
    }
    lines.push(currentLine);
    return lines;
    };

    // Manual table drawing function for PDF (only 5 columns)
    const drawSalaryTable = (doc, data, startY) => {
    const pageWidth = doc.internal.pageSize.width;
    const margin = 14;
    const rowHeight = 12;

    // Column widths for salary - Only 5 columns as requested
    const colWidths = [15, 40, 30, 30, 35]; // #, Employee, Total Salary, Salary Type, Branch

    // Check if we need a new page
    let currentY = startY;
    const neededHeight = (data.length + 1) * rowHeight;
    if (currentY + neededHeight > doc.internal.pageSize.height - 20) {
        doc.addPage();
        currentY = margin;
    }

    // Draw table header
    doc.setFillColor(255, 255, 255);
    doc.setTextColor(25, 118, 210);
    doc.setFont(undefined, 'bold');

    const headers = ['No.', 'Employee', 'Total Salary', 'Salary Type', 'Branch'];
    let xPos = margin;

    // Draw header background
    doc.rect(margin, currentY, pageWidth - (2 * margin), rowHeight, 'F');

    // Draw header text
    headers.forEach((header, index) => {
        const cellX = xPos + 2;
        doc.text(header, cellX, currentY + 7);
        xPos += colWidths[index];
    });

    // Draw header underline
    doc.setDrawColor(25, 118, 210);
    doc.setLineWidth(0.5);
    doc.line(margin, currentY + rowHeight, pageWidth - margin, currentY + rowHeight);

    currentY += rowHeight;

    // Draw table rows
    doc.setFont(undefined, 'normal');
    doc.setTextColor(0, 0, 0);

    data.forEach((row, rowIndex) => {
        // Calculate needed height for this row
        let maxLines = 1;
        const cellLines = row.map((cell, cellIndex) => {
        const text = String(cell);
        const maxWidth = colWidths[cellIndex] - 4;
        const lines = splitTextIntoLines(doc, text, maxWidth);
        maxLines = Math.max(maxLines, lines.length);
        return lines;
        });

        const actualRowHeight = rowHeight * maxLines;

        // Check for page break
        if (currentY + actualRowHeight > doc.internal.pageSize.height - 20) {
        doc.addPage();
        currentY = margin;
        
        // Redraw header on new page
        doc.setFillColor(255, 255, 255);
        doc.setTextColor(25, 118, 210);
        doc.setFont(undefined, 'bold');
        
        // Draw header background
        doc.rect(margin, currentY, pageWidth - (2 * margin), rowHeight, 'F');
        
        xPos = margin;
        headers.forEach((header, index) => {
            doc.text(header, xPos + 2, currentY + 7);
            xPos += colWidths[index];
        });
        
        // Draw header underline
        doc.setDrawColor(25, 118, 210);
        doc.line(margin, currentY + rowHeight, pageWidth - margin, currentY + rowHeight);
        
        currentY += rowHeight;
        doc.setFont(undefined, 'normal');
        doc.setTextColor(0, 0, 0);
        }
        
        // Alternate row colors
        if (rowIndex % 2 === 0) {
        doc.setFillColor(248, 248, 248);
        } else {
        doc.setFillColor(255, 255, 255);
        }
        
        // Draw row background
        doc.rect(margin, currentY, pageWidth - (2 * margin), actualRowHeight, 'F');
        
        // Draw row text with multi-line support
        cellLines.forEach((lines, cellIndex) => {
        xPos = margin + colWidths.slice(0, cellIndex).reduce((sum, width) => sum + width, 0);
        
        lines.forEach((line, lineIndex) => {
            const lineY = currentY + 7 + (lineIndex * rowHeight);
            doc.text(line, xPos + 2, lineY);
        });
        });
        
        currentY += actualRowHeight;
    });

    return currentY;
    };

    // Excel export for Salary - Shows all attributes
    export const exportSalariesToExcel = (salaries, employeeNamesData = [], branchNamesFilterData = [], filters = {}) => {
    try {
        
        // Prepare data for Excel with all attributes
        const excelData = salaries.map((salary, index) => ({
        'No.': index + 1,
        'Salary ID': salary.id,
        'Employee ID': salary.employee_id,
        'Employee Name': getEmployeeName(salary.employee_id, employeeNamesData),
        'Total Salary': parseFloat(salary.total_salary),
        'Salary Type': salary.salary_type || '',
        'Status ID': salary.status,
        'Status': getStatusName(salary.status),
        'Note': salary.note || '',
        'Branch ID': salary.branch_id,
        'Branch Name': getBranchName(salary.branch_id, branchNamesFilterData),
        'Created Date': new Date(salary.created_at).toLocaleDateString('en-GB'),
        'Created Time': new Date(salary.created_at).toLocaleTimeString('en-GB'),
        'Updated Date': new Date(salary.updated_at).toLocaleDateString('en-GB'),
        'Updated Time': new Date(salary.updated_at).toLocaleTimeString('en-GB'),
        'Created At Full': new Date(salary.created_at).toLocaleString('en-GB'),
        'Updated At Full': new Date(salary.updated_at).toLocaleString('en-GB')
        }));

        // Create workbook and worksheet
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(excelData);

        // Auto-size columns
        const maxWidth = excelData.reduce((widths, row) => {
        Object.keys(row).forEach((key, idx) => {
            const length = String(row[key]).length;
            if (!widths[idx] || length > widths[idx]) {
            widths[idx] = length;
            }
        });
        return widths;
        }, []);
        
        worksheet['!cols'] = maxWidth.map(width => ({ width: Math.min(width + 2, 50) }));

        // Add worksheet to workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Salary Records');

        // Generate Excel file and download
        const fileName = `salaries_export_${new Date().toISOString().split('T')[0]}.xlsx`;
        XLSX.writeFile(workbook, fileName);

        return { success: true, fileName };
    } catch (error) {
        console.error('Salaries Excel export failed:', error);
        throw new Error('Failed to export to Excel: ' + error.message);
    }
    };

    // Enhanced PDF export for Salary - Shows only 5 columns
    export const exportSalariesToPDFEnhanced = (salaries,employeeNamesData = [], branchNamesFilterData = [], filters = {}) => {
    try {
        const doc = new jsPDF();
        
        // Set document properties
        doc.setProperties({
        title: 'Salaries Report',
        subject: 'Salaries Export',
        author: companyInfo.name,
        keywords: 'salaries, export, report',
        creator: companyInfo.name
        });
        
        // Title section
        doc.setFontSize(20);
        doc.setTextColor(25, 118, 210);
        doc.text('SALARIES REPORT', 105, 25, { align: 'center' });
        
        // Generation details
        doc.setFontSize(10);
        doc.setTextColor(80, 80, 80);
        let currentY = 35;
        doc.text(`Report Generated: ${new Date().toLocaleString()}`, 14, currentY);
        currentY += 6;
        doc.text(`Total Salary Records: ${salaries.length}`, 14, currentY);
        currentY += 6;
        
        // Calculate total salary amount
        const totalAmount = salaries.reduce((sum, salary) => sum + parseFloat(salary.total_salary || 0), 0);
        doc.text(`Total Amount: ${totalAmount.toLocaleString('en-GB')}`, 14, currentY);
        currentY += 6;
        
        // Filters applied
        if (filters.employee_name || filters.dateFrom || filters.dateTo || filters.salary_type) {
        doc.text('Applied Filters:', 14, currentY);
        currentY += 6;
        
        if (filters.employee_name) {
            doc.text(`• Employee Name: ${filters.employee_name}`, 20, currentY);
            currentY += 6;
        }
        if (filters.salary_type) {
            doc.text(`• Salary Type: ${filters.salary_type}`, 20, currentY);
            currentY += 6;
        }
        if (filters.dateFrom) {
            doc.text(`• From date: ${new Date(filters.dateFrom).toLocaleDateString()}`, 20, currentY);
            currentY += 6;
        }
        if (filters.dateTo) {
            doc.text(`• To date: ${new Date(filters.dateTo).toLocaleDateString()}`, 20, currentY);
            currentY += 6;
        }
        currentY += 6;
        }
        
        // Prepare table data with only 5 columns
        const tableData = salaries.map((salary, index) => [
        (index + 1).toString(),
        getEmployeeName(salary.employee_id, employeeNamesData),
        parseFloat(salary.total_salary).toLocaleString('en-GB')+" " + "Sh",
        salary.salary_type || 'N/A',
        getBranchName(salary.branch_id, branchNamesFilterData)
        ]);
        
        // Draw the table
        drawSalaryTable(doc, tableData, currentY + 5);
        
        const fileName = `salaries_report_${new Date().toISOString().split('T')[0]}.pdf`;
        doc.save(fileName);

        return { success: true, fileName };
    } catch (error) {
        console.error('Salaries PDF export failed:', error);
        throw new Error('Failed to export to PDF: ' + error.message);
    }
    };

    // CSV export for Salary - Shows all attributes
    export const exportSalariesToCSV = (salaries, employeeNamesData = [], branchNamesFilterData = [],) => {
    try {
        const headers = [
        'Salary ID',
        'Employee ID',
        'Employee Name',
        'Total Salary',
        'Salary Type',
        'Status ID',
        'Status',
        'Note',
        'Branch ID',
        'Branch Name',
        'Created Date',
        'Created Time',
        'Updated Date',
        'Updated Time',
        'Created At Full',
        'Updated At Full'
        ];
        
        const csvData = salaries.map(salary => [
        salary.id,
        salary.employee_id,
        `"${getEmployeeName(salary.employee_id, employeeNamesData).replace(/"/g, '""')}"`,
        parseFloat(salary.total_salary)+" " + "UGX",
        `"${(salary.salary_type || '').replace(/"/g, '""')}"`,
        salary.status,
        getStatusName(salary.status),
        `"${(salary.note || '').replace(/"/g, '""')}"`,
        salary.branch_id,
        `"${getBranchName(salary.branch_id, branchNamesFilterData).replace(/"/g, '""')}"`,
        `"${new Date(salary.created_at).toLocaleDateString('en-GB')}"`,
        `"${new Date(salary.created_at).toLocaleTimeString('en-GB')}"`,
        `"${new Date(salary.updated_at).toLocaleDateString('en-GB')}"`,
        `"${new Date(salary.updated_at).toLocaleTimeString('en-GB')}"`,
        `"${new Date(salary.created_at).toLocaleString('en-GB')}"`,
        `"${new Date(salary.updated_at).toLocaleString('en-GB')}"`
        ]);

        const csvContent = [
        headers.join(','),
        ...csvData.map(row => row.join(','))
        ].join('\n');

        const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `salaries_${new Date().toISOString().split('T')[0]}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        return { success: true };
    } catch (error) {
        console.error('Salaries CSV export failed:', error);
        throw new Error('Failed to export to CSV: ' + error.message);
    }
    };